module.exports = __webpack_public_path__ + "ab2.no1.21a49742.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/ab2.no1.jpg
// module id = UO7C
// module chunks = 0